import { render, staticRenderFns } from "./OrdersFBMAdvancedCreationPage.vue?vue&type=template&id=189140c2&scoped=true"
import script from "./OrdersFBMAdvancedCreationPage.vue?vue&type=script&lang=js"
export * from "./OrdersFBMAdvancedCreationPage.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBMAdvancedCreationPage.vue?vue&type=style&index=0&id=189140c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189140c2",
  null
  
)

export default component.exports